export default __webpack_public_path__ + "static/media/bannerCrisBarrosMobile.9ff3b8a7.svg";